import TFGDefenseFilters from './TFGDefenseFilters';

export default TFGDefenseFilters;
